import styled, { css } from 'styled-components';
import { createReadableClass, getColorWithAlpha } from '@elfsight/widget-utils';
import { useCheckoutColors } from '../providers';

export function Divider() {
  const { textColor } = useCheckoutColors();

  return <Component $textColor={textColor} />;
}

const Component = styled.div.attrs<{
  $textColor: string;
}>({
  className: createReadableClass({
    component: 'divider'
  }),
  role: 'separator'
})`
  width: 100%;
  height: 1px;

  ${({ $textColor }) => css`
    background-color: ${getColorWithAlpha($textColor, 0.1)};
  `}
`;
